/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import { ColorGrey6, ColorGreyLight2, ColorWhite } from './palette';

export const skeletonBgLoader = `linear-gradient(
    to right,
    ${ColorGreyLight2} 8%,
    ${ColorGrey6} 33%, 
    ${ColorGreyLight2} 60%)`;

export const skeletonChartCenterBg = ColorWhite;
